(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dev-about-us-usp-slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.dev-about-us-usp-slider').forEach(function(section) {
    const slideshow = section.querySelector('.dev-about-us-usp-slider__slideshow');
    if (!slideshow) return;

    function centerInitialSlide() {
      const scroller = slideshow.querySelector('slideshow-slides');
      if (!scroller) return;
      const initialIndex = parseInt(slideshow.getAttribute('initial-slide') || '0', 10);
      const slides = Array.from(scroller.querySelectorAll('slideshow-slide'));
      const slide = slides[initialIndex];
      if (!slide) return;
      const left = slide.offsetLeft - (scroller.clientWidth - slide.offsetWidth) / 2;
      scroller.scrollLeft = Math.max(0, left);
    }

    function scheduleCenter() {
      requestAnimationFrame(function() {
        requestAnimationFrame(centerInitialSlide);
      });
    }

    if (slideshow.hasAttribute('in-viewport')) {
      scheduleCenter();
    } else {
      const observer = new MutationObserver(function() {
        if (slideshow.hasAttribute('in-viewport')) {
          observer.disconnect();
          scheduleCenter();
        }
      });
      observer.observe(slideshow, { attributes: true, attributeFilter: ['in-viewport'] });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dev-at-your-home"] && !Shopify.designMode) return;
  try {
    
  function setAtYourHomeButtonLabel(btn, label) {
    const labelNodes = btn.querySelectorAll('[data-button-label]');
    if (!labelNodes.length) return;

    for (const node of labelNodes) {
      node.textContent = label;
    }
  }

  function setAtYourHomeButtonStyle(btn, expanded) {
    const styleExpand = btn.dataset.styleExpand || 'button';
    const styleCollapse = btn.dataset.styleCollapse || 'button-secondary';
    const sizeExpand = btn.dataset.sizeExpand || '';
    const sizeCollapse = btn.dataset.sizeCollapse || '';

    if (styleExpand === styleCollapse && sizeExpand === sizeCollapse) return;

    const nextStyle = expanded ? styleCollapse : styleExpand;
    const prevStyle = expanded ? styleExpand : styleCollapse;
    const nextSize = expanded ? sizeCollapse : sizeExpand;
    const prevSize = expanded ? sizeExpand : sizeCollapse;

    if (prevStyle !== nextStyle) {
      btn.classList.remove(prevStyle);
      btn.classList.add(nextStyle);
    }

    if (prevSize && prevSize !== nextSize) {
      btn.classList.remove(prevSize);
    }

    if (nextSize && nextSize !== prevSize) {
      btn.classList.add(nextSize);
    }
  }

  for (const btn of document.querySelectorAll('[data-at-your-home-expand]')) {
    btn.addEventListener('click', () => {
      const section = btn.closest('.dev-at-your-home');
      if (!section) return;

      const expanded = section.classList.toggle('dev-at-your-home--expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');

      const nextLabel = expanded
        ? btn.dataset.labelCollapse || btn.dataset.labelExpand
        : btn.dataset.labelExpand || btn.dataset.labelCollapse;

      if (nextLabel) {
        setAtYourHomeButtonLabel(btn, nextLabel);
      }

      setAtYourHomeButtonStyle(btn, expanded);

      for (const overlay of section.querySelectorAll('.dev-at-your-home__overlay')) {
        overlay.hidden = expanded;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dev-careers-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const hero = document.querySelector('.dev-careers-hero-section');
    if (!hero) return;

    const jumpList = hero.querySelector('.dev-careers-hero__jump-links');
    if (!jumpList) return;

    jumpList.querySelectorAll('a[href="#careers-openings"]').forEach((link) => {
      if (!document.getElementById('careers-openings')) {
        link.closest('li')?.remove();
      }
    });

    if (!jumpList.querySelector('li')) {
      jumpList.closest('.dev-careers-hero__jump')?.remove();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dev-lp-hero"] && !Shopify.designMode) return;
  try {
    
  const initHeroScroll = () => {
    for (const hero of document.querySelectorAll('.dev-lp-hero-wrapper')) {
      const cta = hero.querySelector('[data-hero-cta] a');
      if (!cta) continue;

      cta.addEventListener('click', (e) => {
        const href = cta.getAttribute('href') ?? '';
        if (!href.startsWith('#')) return;
        e.preventDefault();
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollBy({ top: hero.getBoundingClientRect().bottom, behavior: reduced ? 'instant' : 'smooth' });
      });
    }
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initHeroScroll) : initHeroScroll();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dev-stores-list"] && !Shopify.designMode) return;
  try {
    
  class DevStoresTabs extends HTMLElement {
    connectedCallback() {
      this._tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this._panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this._tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this._activate(i));
        tab.addEventListener('keydown', (e) => this._onKeyDown(e, i));
      });

      this._updateStatusBadges();
    }

    _activate(index) {
      this._tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
        tab.classList.toggle('dev-stores__tab--active', active);
      });
      this._panels.forEach((panel, i) => {
        panel.hidden = i !== index;
      });
      this._tabs[index].focus();
    }

    _onKeyDown(e, index) {
      const count = this._tabs.length;
      let next = null;
      if (e.key === 'ArrowRight') next = (index + 1) % count;
      if (e.key === 'ArrowLeft') next = (index - 1 + count) % count;
      if (e.key === 'Home') next = 0;
      if (e.key === 'End') next = count - 1;
      if (next !== null) {
        e.preventDefault();
        this._activate(next);
      }
    }

    _updateStatusBadges() {
      this.querySelectorAll('.dev-stores__status-badge').forEach((badge) => {
        const { timezone, openDays, openTime, closeTime, openLabel, closedLabel } = badge.dataset;
        try {
          const isOpen = this._isStoreOpen(timezone, openDays, openTime, closeTime);
          if (isOpen === null) return;

          badge.classList.toggle('dev-stores__status-badge--open', isOpen);
          badge.classList.toggle('dev-stores__status-badge--closed', !isOpen);

          const dot = document.createElement('span');
          dot.className = 'dev-stores__status-dot';
          dot.setAttribute('aria-hidden', 'true');

          const label = document.createElement('span');
          label.textContent = isOpen ? openLabel : closedLabel;

          badge.replaceChildren(dot, label);
        } catch (_) {
          badge.hidden = true;
        }
      });
    }

    _isStoreOpen(timezone, openWeekdays, openTime, closeTime) {
      const now = new Date();
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: timezone,
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        weekday: 'short'
      }).formatToParts(now);

      const hour = parseInt(parts.find((p) => p.type === 'hour').value) % 24;
      const minute = parseInt(parts.find((p) => p.type === 'minute').value);
      const weekday = parts.find((p) => p.type === 'weekday').value;

      const dayIndex = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 0 };
      const currentDay = dayIndex[weekday];
      if (currentDay === undefined) return null;

      const dayRanges = {
        'mon-fri': [1, 2, 3, 4, 5],
        'mon-sat': [1, 2, 3, 4, 5, 6],
        'mon-sun': [0, 1, 2, 3, 4, 5, 6],
        'tue-sat': [2, 3, 4, 5, 6],
        'tue-sun': [0, 2, 3, 4, 5, 6],
        'wed-sun': [0, 3, 4, 5, 6]
      };

      const validDays = dayRanges[openWeekdays];
      if (!validDays || !validDays.includes(currentDay)) return false;

      const [openH, openM] = openTime.split(':').map(Number);
      const [closeH, closeM] = closeTime.split(':').map(Number);
      const currentMinutes = hour * 60 + minute;

      return currentMinutes >= openH * 60 + openM && currentMinutes < closeH * 60 + closeM;
    }
  }

  if (!customElements.get('dev-stores-tabs')) {
    customElements.define('dev-stores-tabs', DevStoresTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
